import { Box, Text, VStack } from '@elkaso-app/web-design';
import React from 'react';

export interface IDateCell {
  createdAt: string;
  updatedAt: string;
}

export const DateCell: React.FC<IDateCell> = ({ createdAt, updatedAt }) => {
  // Format date to a readable format
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <Box py={2} px={1} minW='160px'>
      <VStack align='start' spacing={2}>
        <Box>
          <Text fontSize='xs' color='gray.500' fontWeight='medium' mb={1}>
            Created
          </Text>
          <Text fontSize='sm' color='gray.700' lineHeight='1.3' fontFamily='mono' letterSpacing='0.3px'>
            {formatDate(createdAt)}
          </Text>
        </Box>

        {createdAt !== updatedAt && (
          <Box>
            <Text fontSize='xs' color='gray.500' fontWeight='medium' mb={1}>
              Updated
            </Text>
            <Text fontSize='sm' color='blue.600' lineHeight='1.3' fontFamily='mono' letterSpacing='0.3px'>
              {formatDate(updatedAt)}
            </Text>
          </Box>
        )}
      </VStack>
    </Box>
  );
};
